module.exports = __webpack_public_path__ + "img/share_wechat_icon.9c0cd4d0.png";